var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliverables(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 18.9999L16.3334 20.3333C16.3334 20.3333 26.3334 18.3333 27.6667 18.3333C29 18.3333 29 19.6666 27.6667 20.9999C26.3334 22.3333 21.6667 26.3333 17.6667 26.3333C13.6667 26.3333 11 24.3333 8.33335 24.3333H1.66669",
    stroke: "#757B83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 16.3333C3.00002 14.9999 5.66669 12.9999 8.33335 12.9999C11 12.9999 17.3334 15.6666 18.3334 16.9999C19.3334 18.3333 16.3334 20.3333 16.3334 20.3333M9.66669 8.99992V3.66659C9.66669 3.31296 9.80716 2.97383 10.0572 2.72378C10.3073 2.47373 10.6464 2.33325 11 2.33325H27C27.3536 2.33325 27.6928 2.47373 27.9428 2.72378C28.1929 2.97383 28.3334 3.31296 28.3334 3.66659V14.3333",
    stroke: "#757B83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 2.33325H22.3334V8.33325H15.6667V2.33325Z",
    stroke: "#757B83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverables);
export default __webpack_public_path__ + "static/media/deliverables.8eb44509816a97dffd6b1e8131cfb01f.svg";
export { ForwardRef as ReactComponent };